import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AssessmentProvider } from './context/AssessmentContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Navigation from './components/Layout/Navigation';
import Home from './pages/Home';
import Assessment from './pages/Assessment';
import Results from './pages/Results';
import './styles/global.css';

const App = () => {
  return (
    <AssessmentProvider>
      <Router>
        <Header />
        <Navigation />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/assessment" component={Assessment} />
          <Route path="/results" component={Results} />
        </Switch>
        <Footer />
      </Router>
    </AssessmentProvider>
  );
};

export default App;